import { render } from "./filepondupload.vue?vue&type=template&id=b1b2e47c"
import script from "./filepondupload.vue?vue&type=script&lang=js"
export * from "./filepondupload.vue?vue&type=script&lang=js"

import "./filepondupload.vue?vue&type=style&index=0&id=b1b2e47c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/filepondupload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1b2e47c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1b2e47c', __exports__)) {
    api.reload('b1b2e47c', __exports__)
  }
  
  module.hot.accept("./filepondupload.vue?vue&type=template&id=b1b2e47c", () => {
    api.rerender('b1b2e47c', render)
  })

}


export default __exports__